import { template, internal, KeyboardDirectionMixin, DirectionSelectionMixin } from '../../../vendor/elix.js';
import CheckableInputBase from '../checkable-input-base.js';
import SelectionController from './selection-controller.js';

const base =
  DirectionSelectionMixin(
  KeyboardDirectionMixin(
    CheckableInputBase
  ));

class TpRadioBase extends base {
  shouldShowPressAnimation() {
    return !this.checked;
  }

  get _selectionController() {
    return SelectionController.getController(this);
  }

  [internal.componentDidMount]() {
    if (super[internal.componentDidMount]) {
      super[internal.componentDidMount]();
    }
    this[internal.nativeInternals] && this[internal.nativeInternals].setFormValue(null);
    this._selectionController.register(this);
    this._selectionController.initialize(this.name);
    this[internal.ids].inner.addEventListener('change', this.onChange.bind(this));

    if (!this.hasAttribute('tabindex')) {
      this.setAttribute('tabindex', 0);
    }
  }

  [internal.goDown]() {
    this.selectNext();
    return true;
  }
  [internal.goLeft]() {
    this.selectPrevious();
    return true;
  }
  selectNext() {
    this._selectionController.focusNext(this);
  }
  selectPrevious() {
    this._selectionController.focusPrevious(this);
  }

  [internal.render](changed) {
    super[internal.render](changed);
    if (changed.checked) {
      const formValue = this.checked ? this.value : null;
      const tabIndex = this.checked ? '0' : '-1';
      this[internal.nativeInternals] && this[internal.nativeInternals].setFormValue(formValue);
      this[internal.ids].inner.setAttribute('tabindex', tabIndex);
      this[internal.ids].inner.checked = this.checked;
    }
  }

  [internal.componentDidUpdate](changed) {
    super[internal.componentDidUpdate](changed);
    if (changed.checked && this.checked) {
      this.dispatchEvent(new Event('change', { composed: true, bubbles: true }));
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._selectionController) {
      this._selectionController.unregister(this);
    }
    this._selectionController = undefined;
  }

  onChange() {
    this.checked = true;
  }

  inputChecked() {
    this._selectionController.update(this);
  }

  get [internal.template]() {
    return template.concat(
      super[internal.template],
      template.html`
        <div class="checkable" id="checkable">
          <input type="radio" id="inner" class="checkable__input" />
          <div class="checkable__background">
            <div class="checkable__outer-border"></div>
            <div class="checkable__inner-element"></div>
          </div>
        </div>
        <style>
          .checkable__inner-element {
            border-color: var(--tp-checkable-color-selected);
            border-radius: 50%;
            border-style: solid;
            border-width: var(--tp-checkable-button-inner-element-size);
          }
          .checkable__input:checked + .checkable__background .checkable__inner-element {
            transform: scale(0.5);
          }
        </style>
      `
    );
  }
}

export default TpRadioBase;
